import React, { useState } from "react";
import { Box, Grid, Backdrop } from "@material-ui/core";
import Heading from "./components/Heading";
import { useStyles } from "./styles";
import { InspectionWeight } from "./InspectionWeight";
import CommonLoader from "src/components/Loader/CommonLoader";

type Props = {
  children?: React.ReactNode;
  index: any;
  value: any;
};

export function WeightTab({ value, index, ...other }: Props): React.ReactElement {
  const classes = useStyles();
  const [loader] = useState(false);
  const [pageHeading] = useState("List of Inspection Weight");

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <>
          <Backdrop className={classes.backdrop} open={loader}>
            <CommonLoader />
          </Backdrop>
          <Box borderColor="grey.200">
            <Heading heading={pageHeading} />
            <Box borderTop={2} mb={1} borderColor="grey.200"></Box>
            <Grid container direction="row">
              <Grid item xs={12} md={12}>
                <InspectionWeight />
              </Grid>
            </Grid>
          </Box>
        </>
      )}
    </div>
  );
}
